export default async (value) => typeof value === 'string'
